(() => {
  const initializeSubtitlePlayers = () => {
    document.querySelectorAll('[data-m27-video-player] video').forEach((video) => {
      if (video.dataset.m27SubtitlesReady === 'true') return;

      const player = video.closest('[data-m27-video-player]');
      const output = player?.querySelector('[data-m27-subtitle-output]');
      const trackElement = video.querySelector('track[data-m27-caption-track]');
      const textTrack = trackElement?.track;
      if (!output || !textTrack) return;

      video.dataset.m27SubtitlesReady = 'true';
      const openingSubtitle = output.textContent.trim();
      textTrack.mode = 'hidden';

      const renderSubtitle = () => {
        const cue = textTrack.activeCues?.[0];
        const finalCue = textTrack.cues?.[textTrack.cues.length - 1];
        output.textContent = cue?.text?.replace(/<[^>]*>/g, '').trim()
          || (video.ended ? finalCue?.text?.trim() : '')
          || (video.currentTime < 0.05 ? openingSubtitle : '');
      };

      textTrack.addEventListener('cuechange', renderSubtitle);
      trackElement.addEventListener('load', renderSubtitle);
      ['loadedmetadata', 'timeupdate', 'seeked', 'play', 'pause', 'ended'].forEach((eventName) => {
        video.addEventListener(eventName, renderSubtitle);
      });
      renderSubtitle();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSubtitlePlayers, { once: true });
  } else {
    initializeSubtitlePlayers();
  }

  document.addEventListener('shopify:section:load', initializeSubtitlePlayers);
})();
